// import apiClient from "./apiClient";

// const authService = {
//   // Login method
//   login: async ({ email, password, ip, device }) => {
//     try {
//       const response = await apiClient.post("/api/Auth/Login", {
//         email,
//         password,
//         ip,
//         Device: device,
//       });
//       return response.data; // returns { token, userInfo, etc. }
//     } catch (error) {
//       // Handle API errors properly
//       if (error.response) {
//         return { error: error.response.data || "Login failed" };
//       } else {
//         return { error: "Network error. Please try again." };
//       }
//     }
//   },
// };

// export default authService;

import apiClient from "./apiClient";

const login = async (email, password, ip, device) => {
  try {
    // Call backend API
    const response = await apiClient.post("/api/Auth/Login", {
      email,
      password,
      ip,
      device,
    });

    const data = response.data;
    
    if (data && data.JWTToken) {
      localStorage.setItem("authToken", data.JWTToken);
      localStorage.setItem("userID", data.userID);
      localStorage.setItem("userRole", data.userRole);
      localStorage.setItem("lastLogin", data.lastLogin);
    }

    return data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { status: "Fail", message: "Something went wrong" };
  }
};

export default { login };



